import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
// import _ from 'lodash';
import classNames from 'classnames';
import { Button } from 'components';
import './AdvisorPicker.scss';

const AdvisorPicker = ({
  data, onSubmit, rtl, intl,
}) => {
  const [selected, updateSelected] = useState(null);
  const [isSelected, setSelect] = useState(false);
  const parseAdvisor = (advisor) => {
    switch (advisor) {
      case 'Deena Yousef Al-Refai':
        return 'deenaAlRefai';
      case 'Abdullah Anwar Al-Nouri':
        return 'abdullahAlNouri';
      case 'Abdullatif Waleed Alnusif':
        return 'abdullatifAlnusif';
      case 'Mohammed F. AlSmaiee':
        return 'mohammedAlsmaiee';
      case 'Mariam Al Marzouq':
        return 'mariamAlMarzouq';
      default:
        return null;
    }
  };
  const handleClick = (payload) => {
    updateSelected(payload.title);

    if (typeof onSubmit === 'function') {
      onSubmit(payload.title, {
        toTranslate: false,
        icon: payload.icon,
        isRoundIcon: true,
        managerID: payload.id,
        advisorName: payload.id === 'anyOfThem' ? payload.title : intl.formatMessage({ id: parseAdvisor(payload.title) }),
        advisorTitle: payload.id === 'anyOfThem' ? '-' : intl.formatMessage({ id: payload.desc }),
      });
    }
  };

  return (
    <div className="nw-advisor-picker">
      {data && data.map((item, idx) => {
        const advisorClass = classNames({
          'nw-advisor-picker__advisor': true,
          'nw-advisor-picker__advisor--normal': !item.icon,
          'nw-advisor-picker__advisor--checked': item.title === selected,
          'nw-advisor-picker__advisor--rtl': rtl,
        });
        return (
          <Fragment key={idx}>
            {item.id === 'anyOfThem'
              ? (
                <div className={advisorClass}>
                  <Button
                    onButtonClick={() => {
                      if (!isSelected) {
                        setSelect(true);
                        handleClick(item);
                      }
                    }}
                    isAnyOption
                    value={item.title}
                  />
                </div>
              ) : (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <div
                  className={advisorClass}
                  onClick={() => {
                    if (!isSelected) {
                      setSelect(true);
                      handleClick(item);
                    }
                  }}
                >
                  {item.icon && <div className="nw-advisor-picker__avatar" style={{ backgroundImage: `url(${item.icon})` }} />}
                  <div className="nw-advisor-picker__desc">
                    <h5>{intl.formatMessage({ id: parseAdvisor(item.title) })}</h5>
                    {item.desc && <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: item.desc }) }} />}
                  </div>
                  <span className="nw-advisor-picker__checkbox" />
                </div>
              )
            }
          </Fragment>
        );
      })}
    </div>
  );
};

AdvisorPicker.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  /** is RTL */
  rtl: PropTypes.bool,
};

AdvisorPicker.defaultProps = {
  data: [],
  rtl: false,
};

export default injectIntl(AdvisorPicker);
